export default "__VITE_ASSET__1VXM$gmw__"